import React, { useState } from "react";
import Footer from "./Footer";
import API from "./axiosInstance";

function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  // 🔹 HANDLE INPUT CHANGE
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔹 HANDLE FORM SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await API.post("/contact", form); // Backend call
      alert("Your message has been sent successfully ✅");

      setForm({
        name: "",
        email: "",
        message: "",
      });
    } catch (err) {
      console.error(err);
      alert("❌ Message send failed");
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* ===== CONTENT ===== */}
      <div style={{ flex: 1, padding: "40px", maxWidth: 900, margin: "auto" }}>
        <h1 style={{ textAlign: "center", marginBottom: 20 }}>Contact Us</h1>

        <p style={{ textAlign: "center", marginBottom: 30 }}>
          Have questions or need support? We’d love to hear from you.
        </p>

        <div
          style={{
            display: "flex",
            gap: 30,
            flexWrap: "wrap",
          }}
        >
          {/* ===== CONTACT INFO ===== */}
          <div style={{ flex: 1, minWidth: 250 }}>
            <h3>📍 Our Address</h3>
            <p>
              KingShop Pvt Ltd <br />
              korba C.G., India
            </p>

            <h3>📞 Phone</h3>
            <p>+91-8966825777</p>

            <h3>📧 Email</h3>
            <p>kingshoppy.as@gmail.com</p>

            <h3>🕒 Working Hours</h3>
            <p>Mon – Sat: 10:00 AM – 6:00 PM</p>
          </div>

          {/* ===== CONTACT FORM ===== */}
          <div
            style={{
              flex: 1,
              minWidth: 250,
              border: "1px solid #ddd",
              padding: 20,
              borderRadius: 10,
              background: "#fafafa",
            }}
          >
            <h3>✉️ Send Message</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange} // ✅ handleChange added
                required
                style={inputStyle}
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange} // ✅ handleChange added
                required
                style={inputStyle}
              />

              <textarea
                name="message"
                placeholder="Your Message"
                value={form.message}
                onChange={handleChange} // ✅ handleChange added
                required
                rows={4}
                style={inputStyle}
              />

              <button style={buttonStyle}>Send Message</button>
            </form>
          </div>
        </div>
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: 10,
  marginBottom: 15,
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14,
};

const buttonStyle = {
  width: "100%",
  padding: 12,
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
  fontSize: 16,
};

export default ContactUs;
